import { MEMBER_ROUTES } from "./routes";

export const tabOptions = [
  { label: "Personal Details", value: MEMBER_ROUTES["personal-details"] },
  { label: "Member Summary", value: MEMBER_ROUTES["member-summary"] },
  { label: "Workout Plan", value: MEMBER_ROUTES["workout-plan"] },
  //{ label: "Reports", value: MEMBER_ROUTES["reports"] },
  { label: "Journal", value: MEMBER_ROUTES["journal"] },
  // { label: "Messages", value: MEMBER_ROUTES["messages"] },
];
